export default __webpack_public_path__ + "static/favicon-810216248f76138d5bb6b511695c84c3.png";